import React from "react";
import ReactDOM from "react-dom/client";
import "@assistancekaren/react-components/styles.css";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AkThemeProvider } from "@assistancekaren/react-components";
import { RecoilRoot } from "recoil";

const akComponentsTheme: React.ComponentProps<typeof AkThemeProvider>["theme"] = {
  colors: {
    border: {
      main: "var(--theme-colors-border-main)",
      input: "var(--theme-colors-border-input)",
    },
  },
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <RecoilRoot>
        <AkThemeProvider theme={akComponentsTheme}>
          <App />
        </AkThemeProvider>
      </RecoilRoot>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
